<template>
  <div class="container">
    <section class="row">
      <div class="col-md-12 text-center">
        <h2 class="fs-3">Download Our Capabilities Statement</h2>
        <a href="/capabilities-statement.pdf" download>Download PDF</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {

}
</script>